import { render, staticRenderFns } from "./ruleDetail.vue?vue&type=template&id=251939d6&scoped=true&"
import script from "./ruleDetail.vue?vue&type=script&lang=js&"
export * from "./ruleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ruleDetail.vue?vue&type=style&index=0&id=251939d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251939d6",
  null
  
)

export default component.exports